module.exports = __webpack_public_path__ + "static/img/logo-hljh.d7d8258.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/logo-hljh.png
// module id = J6WF
// module chunks = 1